<app-dark-theme class="home-theme-toggle"></app-dark-theme>

<div class="container">
  <div class="pricing-header p-3 pt-md-5 pb-md-4 text-center">
    <img
      src="assets/images/logo-text.svg"
      class="logo mb-4"
      alt="Phoenix Event Display Logo"
    />
    <p class="lead">Application for visualizing High Energy Physics data.</p>
  </div>

  <div class="row centered">
    <div class="card">
      <img
        class="card-img-top"
        src="assets/images/playground.svg"
        alt="Playground feature illustration"
      />
      <div class="card-body d-flex flex-column">
        <h5 class="card-title">Playground</h5>
        <p class="card-text">
          Get started with the different Phoenix features.
        </p>
        <a routerLink="/playground" class="btn btn-primary">Show</a>
      </div>
    </div>

    <div class="card">
      <img
        class="card-img-top"
        src="assets/images/geometry.svg"
        alt="Geometry display illustration"
      />
      <div class="card-body d-flex flex-column">
        <h5 class="card-title">Geometry display</h5>
        <p class="card-text">This test should show some simple geometry.</p>
        <a routerLink="/geometry" class="btn btn-primary">Show</a>
      </div>
    </div>

    <div class="card">
      <img
        class="card-img-top"
        src="assets/images/atlas.svg"
        alt="ATLAS detector visualization"
      />
      <div class="card-body d-flex flex-column">
        <h5 class="card-title">ATLAS</h5>
        <p class="card-text">Show the ATLAS detector. One simple event.</p>
        <a routerLink="/atlas" class="btn btn-primary">Show</a>
      </div>
    </div>

    <div class="card">
      <img
        class="card-img-top"
        src="assets/icons/physics.svg"
        alt="Masterclass particle tagging illustration"
      />
      <div class="card-body d-flex flex-column">
        <h5 class="card-title">Masterclass</h5>
        <p class="card-text">
          Tag particles and measure invariant mass. Simplified UI for students.
        </p>
        <a routerLink="/atlas-masterclass" class="btn btn-primary">Show</a>
      </div>
    </div>

    <div class="card">
      <img
        class="card-img-top"
        src="assets/images/lhcb.svg"
        alt="LHCb detector visualization"
      />
      <div class="card-body d-flex flex-column">
        <h5 class="card-title">LHCb</h5>
        <p class="card-text">Show the LHCb detector. One simple event.</p>
        <a routerLink="/lhcb" class="btn btn-primary">Show</a>
      </div>
    </div>

    <div class="card">
      <img
        class="card-img-top"
        src="assets/images/cms.svg"
        alt="CMS detector visualization"
      />
      <div class="card-body d-flex flex-column">
        <h5 class="card-title">CMS</h5>
        <p class="card-text">Show the CMS detector. One simple event.</p>
        <a routerLink="/cms" class="btn btn-primary">Show</a>
      </div>
    </div>

    <div class="card">
      <img
        class="card-img-top"
        src="assets/images/trackml2.png"
        alt="TrackML visualization"
      />
      <div class="card-body d-flex flex-column">
        <h5 class="card-title">TrackML</h5>
        <p class="card-text">
          Visualisation for TrackML. Shows how to write a custom event loader.
        </p>
        <a routerLink="/trackml" class="btn btn-primary">Show</a>
      </div>
    </div>
  </div>
</div>

<footer>
  <p>
    <em>{{ year }}</em> Phoenix Project
  </p>
  <p>
    <a href="https://github.com/HSF/phoenix"> Github </a> -
    <a href="https://github.com/HSF/phoenix/blob/main/README.md">
      Documentation
    </a>
  </p>
  <p class="version">
    <a [href]="versionLink" target="_blank" rel="noopener">{{
      versionLabel
    }}</a>
  </p>
</footer>
